document.addEventListener("DOMContentLoaded", () => {
  const btnDesktop = document.getElementById("download-pdf-btn");
  const btnMobile = document.getElementById("download-pdf-btn_mobile");

  console.log(btnDesktop, btnMobile, "buttons loaded");

  if (!btnDesktop && !btnMobile) return;

  if (window.pdfHandlerInitialized) {
    console.log("PDF handlers already initialized — skipping duplicate setup.");
    return;
  }
  window.pdfHandlerInitialized = true;

  if (window.shopifyProduct) {
    console.log("Shopify Product Data:", window.shopifyProduct);
    const product = window.shopifyProduct;
    if (product.featured_image) {
      const imageUrl = product.featured_image.startsWith("//")
        ? `https:${product.featured_image}`
        : product.featured_image.startsWith("http")
        ? product.featured_image
        : `https://${product.featured_image}`;

      const imgEl = document.querySelector(".main-product-image img");
      if (imgEl) imgEl.src = imageUrl;
    }
  } else {
    console.warn("Product data not found. Did you add {{ product | json }}?");
  }

  const generatePDF = async (source) => {
    const sheet = document.getElementById("tech-sheet");
    if (!sheet) return;

    sheet.style.display = "block";
    sheet.scrollIntoView(true);
    window.scrollTo(0, 0);

    const opt = {
      margin: [0, 0, 0, 0],
      filename: `${
        window.shopifyProduct
          ? `${window.shopifyProduct.title
              .replace(/[^\w\s]/g, "")
              .replace(/\s+/g, "_")}_Tech_Sheet.pdf`
          : "product_tech_sheet.pdf"
      }`,
      html2canvas: {
        scale: 5,
        useCORS: true,
        allowTaint: true,
        backgroundColor: "#ffffff",
        scrollX: -window.scrollX,
        scrollY: -window.scrollY,
      },
      jsPDF: {
        unit: "px",
        format: [1545, 2000],
        orientation: "portrait",
      },
      pagebreak: { mode: ["css", "legacy"] },
    };

    await html2pdf().set(opt).from(sheet).save();
    sheet.style.display = "none";
  };

  if (btnDesktop) {
    btnDesktop.addEventListener("click", (e) => {
      e.stopPropagation();
      if (window.innerWidth > 768) {
        console.log("desktop");
        generatePDF("desktop");
      }
    });
  }

  if (btnMobile) {
    btnMobile.addEventListener("click", (e) => {
      e.stopPropagation();
      if (window.innerWidth <= 768) {
        console.log("mobile");
        generatePDF("mobile");
      }
    });
  }
});
